<fgb-banner [pageTitle]="'offers.page.title'"></fgb-banner>

<fgb-page-header [pageTitle]="'offers.page.title'" [backButtonLink]="'/'" />

<fgb-endurance-zone></fgb-endurance-zone>
